import _ from 'lodash';

import {
  PERSON_ROLES,
  PRAECE_ADMIN_ROLES,
  PRAECE_LEAD_ROLES,
  PRAECE_OPERATIONS_ROLES,
  PRAECE_ROLES,
  USER_ROLES
} from 'constants';
import { alerts } from 'modules/alerts/actions';
import Rest from 'services/data/rest';
import * as pageData from 'modules/page-data/actions';
import * as socket from 'services/socket';

const contactTypeOrder = {
  Work: 1,
  Office: 2,
  'PO Box': 3,
  Mobile: 4,
  Home: 5,
  Personal: 6,
  Other: 7
};

const statusOrder = {
  Active: 1,
  Disabled: 2,
  Archived: 3
};


export default class Person extends Rest {
  static path = 'person';
  static defaultQuery = {
    load: ['primaryEmail', 'phoneNumbers'],
    sort: ['firstName', 'lastName']
  };
  static contactQuery = {
    where: { role: { not: { in: USER_ROLES } } },
    sort: ['firstName', 'lastName']
  };
  static praeceUserQuery = {
    where: { company: 1 },
    load: ['team'],
    sort: ['firstName', 'lastName']
  };

  static mapFilters(filters) {
    const { personStatus, personRole, tags, ...where } = filters;

    if (personStatus && personStatus.length) where.status = { in: personStatus };
    if (personRole && personRole.length) where.role = { in: personRole };
    if (tags && tags.length) where.tags = { '?|': tags };

    return where;
  }
  
  static fullName(user) {
    if (!user || _.isEmpty(user)) return;

    return `${user.firstName} ${user.lastName}`;
  }

  static getInitials(user) {
    if (!user || !user.firstName || !user.lastName) return '';
    return `${user.firstName.substring(0, 1)}${user.lastName.substring(0, 1)}`;
  }

  static getOrderedContactInfo(info) {
    if (!info || !info.length) return [];

    return _.sortBy(info, item => contactTypeOrder[item.type]);
  }

  static getInitialsFromName(user) {
    const names = _.split(user, ' ');
    return `${names[0].substring(0, 1)}${names[1].substring(0, 1)}`;
  }

  static initializeSocket() {
    Person.loadSelectUsers();

    socket.registerSocket('user', (changedUser) => {
      pageData.updateOne('selectUsers', changedUser, ['lastName']);
    }, Person.loadSelectUsers);
  }

  static loadSelectUsers() {
    Person.find(Person.praeceUserQuery)
      .then((users) => {
        pageData.update('selectUsers', users);
      })
      .catch(alerts.catchError);
  }

  static isPraece(user) {
    return _.includes(PRAECE_ROLES, user.role);
  }

  static isPraecePerson(user) {
    return _.includes(_.intersection(PRAECE_ROLES, PERSON_ROLES), user.role);
  }

  static isOperations(user) {
    return _.includes(PRAECE_OPERATIONS_ROLES, user.role);
  }

  static isLead(user) {
    return _.includes(PRAECE_LEAD_ROLES, user.role);
  }

  static isAdmin(user) {
    return _.includes(PRAECE_ADMIN_ROLES, user.role);
  }

  static isUser(user) {
    return _.includes(USER_ROLES, user.role);
  }

  static isDisabled(user) {
    return user.status === 'Disabled';
  }

  static isArchived(user) {
    return user.status === 'Archived';
  }

  static sortPeople(people) {
    return _.sortBy(people, [person => statusOrder[person.status], 'firstName', 'lastName']);
  }
}
